import React, { useMemo } from "react";
import { icon, label, quote } from "../../../config";
import SearchInput from "./SearchInput";
import TabContent from "./TabContent";
import { isTrueBit } from "../../../utils";

/**
 * TaskIdTab component for rendering the task ID tab content
 * @author Muskan Thakur
 */
const TaskIdTab = ({
  recentHistoryList,
  taskSearchText,
  handleTaskSearch,
  selectedIndex,
  insertTaskChip,
  containerRef,
  handleKeyDown,
  searchResults,
  showLoader,
}) => {
  const recentTasks = recentHistoryList?.slice(0, 3) || [];

  /**
   * Get tasks to display - either search results or recent tasks
   * @author Muskan Thakur
   */
  const displayTasks = useMemo(() => {
    if (taskSearchText && taskSearchText.trim().length > 1) {
      return searchResults || [];
    }
    return recentTasks;
  }, [taskSearchText, searchResults, recentTasks]);

  return (
    <>
      <SearchInput
        placeholder={label.SEARCH_TASKS}
        value={taskSearchText}
        onChange={handleTaskSearch}
        onKeyDown={handleKeyDown}
      />
      <TabContent containerRef={containerRef}>
        {showLoader ? (
          <div className='no-result'>Searching...</div>
        ) : displayTasks?.length > 0 ? (
          displayTasks?.map((task, index) => (
            <div
              key={task?.Id || task?.id || index}
              className={`dt-editor-users-list cursor-pointer ${index === selectedIndex ? "user-selected" : ""}`}
              onClick={() => insertTaskChip && insertTaskChip(task)}>
              {!!(task.IsTaskClosed )&&(
                <span className='mr-2'>{icon.CIRCLE_CHECK_GREEN}</span>
              )}
              <span className='text-nowrap mr-2'>{task?.Code || task?.code}</span>
              <span>{task?.Name || task?.name}</span>
            </div>
          ))
        ) : (
          <div className='no-result'>{quote.NO_RESULT_FOUND}</div>
        )}
      </TabContent>
    </>
  );
};

export default React.memo(TaskIdTab);
